import { Overline, Reveal } from "./Primitives";
import { useT } from "@/lib/i18n";

export const Process = () => {
  const t = useT().process;
  return (
    <section className="py-24 md:py-36 bg-[var(--bg2)]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Overline>{t.over}</Overline>
          <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">{t.title}</h2>
        </Reveal>
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--line)] border border-[var(--line)] rounded-[24px] overflow-hidden">
          {t.steps.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.1} className="bg-[var(--bg2)]">
              <div className="group p-8 md:p-10 h-full min-h-[260px] flex flex-col justify-between hover:bg-[#231f1c] transition-colors duration-500" data-testid={`process-step-${i}`}>
                <span className="font-display italic text-7xl text-transparent outline-text group-hover:text-[var(--gold)] transition-colors duration-500">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-3xl">{s.t}</h3>
                  <p className="mt-3 text-stone-300 text-sm leading-relaxed">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
